/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Page_Toggle_DescInputs */

const en_community_page_toggle_desc = /** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable a dedicated community page where visitors can engage in discussions.`)
};

const es_community_page_toggle_desc = /** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilita una página comunitaria dedicada donde los visitantes puedan participar en discusiones.`)
};

const fr_community_page_toggle_desc = /** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activez une page de communauté dédiée où les visiteurs peuvent participer à des discussions.`)
};

const de_community_page_toggle_desc = /** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiviere eine dedizierte Community-Seite, auf der Besucher an Diskussionen teilnehmen können.`)
};

const id_community_page_toggle_desc = /** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan halaman komunitas khusus tempat pengunjung dapat terlibat dalam diskusi.`)
};

/** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */
const ja_community_page_toggle_desc = en_community_page_toggle_desc;

/** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */
const zh_community_page_toggle_desc = en_community_page_toggle_desc;

/** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */
const ar_community_page_toggle_desc = en_community_page_toggle_desc;

/** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */
const it_community_page_toggle_desc = en_community_page_toggle_desc;

/** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */
const ru_community_page_toggle_desc = en_community_page_toggle_desc;

/** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */
const pt_community_page_toggle_desc = en_community_page_toggle_desc;

/** @type {(inputs: Community_Page_Toggle_DescInputs) => LocalizedString} */
const ko_community_page_toggle_desc = en_community_page_toggle_desc;

/**
* | output |
* | --- |
* | "Enable a dedicated community page where visitors can engage in discussions." |
*
* @param {Community_Page_Toggle_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_page_toggle_desc = /** @type {((inputs?: Community_Page_Toggle_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Page_Toggle_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_page_toggle_desc(inputs)
	if (locale === "es") return es_community_page_toggle_desc(inputs)
	if (locale === "fr") return fr_community_page_toggle_desc(inputs)
	if (locale === "de") return de_community_page_toggle_desc(inputs)
	if (locale === "ja") return ja_community_page_toggle_desc(inputs)
	if (locale === "zh") return zh_community_page_toggle_desc(inputs)
	if (locale === "ar") return ar_community_page_toggle_desc(inputs)
	if (locale === "id") return id_community_page_toggle_desc(inputs)
	if (locale === "it") return it_community_page_toggle_desc(inputs)
	if (locale === "ru") return ru_community_page_toggle_desc(inputs)
	if (locale === "pt") return pt_community_page_toggle_desc(inputs)
	return ko_community_page_toggle_desc(inputs)
});